export enum ExternalSegmentBackendTypes {
  AUTO = 'AUTO',
  BANKING_INVESTING = 'BANKING & INVESTING',
  BOOKS_MAGAZINES = 'BOOKS & MAGAZINES',
  CHARITABLE_DONORS = 'CHARITABLE DONORS',
  CPG = 'CPG',
  CREDIT_DEBIT_CARDS = 'CREDIT & DEBIT CARDS',
  DEMOGRAPHICS = 'DEMOGRAPHICS',
  FINANCIALS = 'FINANCIALS',
  FOOD_COOKING = 'FOOD & COOKING',
  FOOD_DRINK = 'FOOD & DRINK',
  HEALTHCARE = 'HEALTHCARE',
  HOME_REAL_ESTATE = 'HOME & REAL ESTATE',
  HOUSEHOLD = 'HOUSEHOLD',
  INSURANCE = 'INSURANCE',
  LIFESTYLES_INTERESTS = 'LIFESTYLES & INTERESTS',
  PURCHASE_BEHAVIORS = 'PURCHASE BEHAVIORS',
  PURCHASE_HISTORY = 'PURCHASE HISTORY',
  RETAIL = 'RETAIL',
  SPORTS = 'SPORTS',
  TECHNOLOGY_CONNECTIVITY = 'TECHNOLOGY & CONNECTIVITY',
  TRAVEL = 'TRAVEL',
  BRAND = 'BRAND',
  ONLINE_BRAND = 'ONLINE_BRAND',
  CATEGORY = 'CATEGORY',
  IAB_CATEGORY = 'IAB_CATEGORY',
  GEO_BEHAVIOR = 'GEO_BEHAVIOUR',
  EVENTS = 'EVENTS',
  APP_CATEGORY = 'APP_CATEGORY',
  INTENT = 'INTENT',
  DEVICE_CARRIER = 'DEVICE_CARRIER',
  POLITICAL = 'POLITICAL',
  TRANSACTIONAL = 'TRANSACTIONAL',
  APP_USAGE = 'APP USAGE',
  BRAND_AFFINITIES = 'BRAND AFFINITIES',
  INTERESTS = 'INTERESTS',
  PLACE_VISITS = 'PLACE_VISITS',
  SEASONAL = 'SEASONAL',
  EATING_PLACES = 'EATING PLACES',
  APPAREL = 'APPAREL',
  GENERAL_MERCHANDISE_STORES = 'GENERAL MERCHANDISE STORES',
  ART_MEDIA = 'ART & MEDIA',
  GROCERY_DRUG_CONVENIENCE_STORES = 'GROCERY, DRUG & CONVENIENCE STORES',
  FINANCIAL_SERVICES = 'FINANCIAL SERVICES',
  HOME_IMPROVEMENT_FURNISHINGS = 'HOME IMPROVEMENT & FURNISHINGS',
  SPECIALTY_RETAIL = 'SPECIALTY RETAIL',
  AUTOMOTIVE_AND_CARS = 'AUTOMOTIVE & CARS',
  ENTERTAINMENT = 'ENTERTAINMENT',
  TECHNOLOGY = 'TECHNOLOGY',
  RETAIL_SHOPPING = 'RETAIL SHOPPING',
  SPENDING_BEHAVIOR = 'SPENDING BEHAVIOR',
  SMALL_BUSINESS = 'SMALL BUSINESS',
  TRAVEL_TOURISM = 'TRAVEL & TOURISM',
  SMARTPHONE = 'SMARTPHONE',
  TELECOMMUNICATIONS_CABLE = 'TELECOMMUNICATIONS / CABLE',
  SERVICES = 'SERVICES',
  EDUCATION = 'EDUCATION',
  WELLNESS = 'WELLNESS',
  PERSONAS = 'PERSONAS',
}
